/* eslint-disable @typescript-eslint/member-ordering */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { RestService } from '../rest.service';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { Router } from '@angular/router';
import { ModalsComponent } from '../modals/modals.component';
import { MatDialog } from '@angular/material/dialog';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';



@Component({
  selector: 'usb-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.scss'],
  providers: [DynamicFontSizePipe]
})
export class SuggestionComponent implements OnInit, OnDestroy {
  public fontSizeAdjustments = { 5: -1, 6: -1, 8: -2, 10: -3, 12: -5, 14: -6 };

  @Input() getClientsSettingAppBooking: any;
  @Input() actualItinerary: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Input() paymentAgencyActive: any;
  @Input() actualLastSearchedDestination: any;
  @Output() suggestionsCategories: EventEmitter<any> = new EventEmitter<any>();
  @Output() reloadEmmit: EventEmitter<any> = new EventEmitter<any>();
  suggestions: any;
  // Old state kept for backward compatibility with getSuggestionsTours()
  sugestionEssencial: any[] = [];
  sugestionImportant: any;
  noData = false;

  // Stable per-destination data (destinationsCarousel slides reference these via realIndex).
  sugestionByDestination: Array<{
    destination: string;   // IATA, e.g. "BUE"
    cityName: string;       // human-readable, e.g. "Ciudad Autónoma de Buenos Aires"
    important: any;         // first item of the group (highest _rank_score)
    essencial: any[];       // remaining items of the group
  }> = [];

  // Autoplay state
  private autoplayInterval: any = null;
  private autoplayDelayMs = 10000; // 10 seconds
  isHovered = false;
  private isUserInteracting = false;
  private userInteractionTimeout: any = null;
  currentSlideIndex = 0; // 0-based index into sugestionByDestination

  get activeDotIndex(): number {
    return this.currentSlideIndex;
  }

  get totalDots(): number {
    return this.sugestionByDestination.length;
  }

  // ViewChild reference for the native scroll-snap viewport
  @ViewChild('carouselViewport') carouselViewport!: ElementRef<HTMLElement>;

  modalRef: BsModalRef;
  modalTours: any;
  payload: any;

  constructor(public dialog: MatDialog,private _restService: RestService, private userService: UserService, private router: Router, private dynamicFontSizePipe: DynamicFontSizePipe) { }

  // ─── Autoplay methods ───────────────────────────────────────────────────────

  private startAutoplay(): void {
    this.stopAutoplay();
    if (this.sugestionByDestination.length <= 1) {
      return; // No autoplay needed for single destination
    }
    this.autoplayInterval = setInterval(() => {
      if (!this.isHovered && !this.isUserInteracting) {
        this.nextSlide();
      }
    }, this.autoplayDelayMs);
  }

  private stopAutoplay(): void {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  private nextSlide(): void {
    if (this.sugestionByDestination.length === 0) {
      return;
    }
    const nextIndex = (this.currentSlideIndex + 1) % this.sugestionByDestination.length;
    this.goToSlide(nextIndex);
  }

  goToSlide(index: number): void {
    if (index < 0 || index >= this.sugestionByDestination.length) {
      return;
    }
    this.currentSlideIndex = index;
    const el = this.carouselViewport?.nativeElement;
    if (!el) {
      return;
    }
    el.scrollTo({ left: index * el.clientWidth, behavior: 'smooth' });
  }

  pauseAutoplayForUserInteraction(): void {
    this.isUserInteracting = true;
    if (this.userInteractionTimeout) {
      clearTimeout(this.userInteractionTimeout);
    }
    this.userInteractionTimeout = setTimeout(() => {
      this.isUserInteracting = false;
    }, this.autoplayDelayMs);
  }

  onCarouselScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const slideWidth = el.clientWidth;
    if (slideWidth > 0) {
      const newIndex = Math.round(el.scrollLeft / slideWidth);
      if (newIndex !== this.currentSlideIndex && newIndex >= 0 && newIndex < this.sugestionByDestination.length) {
        this.currentSlideIndex = newIndex;
        this.pauseAutoplayForUserInteraction();
      }
    }
  }

  /**
   * Computes the display price for a raw suggestion item, using the same
   * USD-base + currencyAgency rate formula as getSuggestionsTours().
   */
  computePrice(item: any): number {
    const USDbaseSuggestion = this.currencies?.find(c => c.code === item?.additionalInfo?.currency)?.rate;
    const adultOption = item?.additionalInfo?.tours?.options?.[0]?.profility?.find((c: any) => c.paxType === 'ADULT');
    const netPrice = adultOption?.netPriceBooking;
    if (!USDbaseSuggestion || !netPrice) {
      return 0;
    }
    return (netPrice / USDbaseSuggestion) * (this.currencyAgency?.rate ?? 1);
  }

  ngOnInit(): void {
    this.getRecommends();
  }

  ngOnDestroy(): void {
    this.stopAutoplay();
    if (this.userInteractionTimeout) {
      clearTimeout(this.userInteractionTimeout);
    }
  }

          getRecommends(): void {
            const itineraryPayload = this.actualItinerary.destination.map((dest: any) => ({
              providerId: null,
              categoriesId: [9],
              origin: '',
              city: dest?.destination_info?.cityName || dest?.cityName || dest?.iata_code || '',
              priceFrom: 0,
              priceTo: 20000,
              market: 2,
              others: {
                maxRequestTimeOnSeconds: 120,
                minNumResults: 4,
                maxNumResultsPerAdapter: '',
                tours: { adults: 1, children: [] }
              },
              destination: dest.iata_code,
              agencyId: this.actualItinerary.agency_id,
              nationality: 'US',
              arrivalDate: dest.destination_info?.arrival,
              departureDate: dest.destination_info?.departure
            }));

            const payload = this.appendSearchedIfMissing(itineraryPayload);

            const dataSuggestion: any = {
              id: this.actualItinerary?.id,
              userId: this.userService._agentID,
              payload
            };

            this._restService.doPost('app', 'suggestionsByID', dataSuggestion).subscribe({
              next: (data: any) => {
                this.populateSuggestionsFromRecommends(data);
              },
              error: (error: HttpErrorResponse) => {
                console.error('RECOMMENDS_ERROR', error);
                this.noData = true;
              }
            });
          }

          /**
           * Groups and sorts recommendation items by destination, then builds per-destination
           * carousel state (important + essencial) for the new carousel layout.
           */
          populateSuggestionsFromRecommends(data: any): void {
            if (!data || !data.TICKETS || !Array.isArray(data.TICKETS.items)) {
              this.noData = true;
              return;
            }

            const items = data.TICKETS.items;
            // Items without _destination are skipped (assigned to no group).
            const grouped = new Map<string, any[]>();
            for (const item of items) {
              const key = item._destination || '_UNGROUPED';
              if (!grouped.has(key)) {
                grouped.set(key, []);
              }
              grouped.get(key)!.push(item);
            }

            const result: any = [];
            const itineraryDestinations = this.actualItinerary?.destination || [];

            grouped.forEach((groupItems, iataCode) => {
              // Sort descending by _rank_score (treat null/missing as 0)
              groupItems.sort((a, b) => (b._rank_score ?? 0) - (a._rank_score ?? 0));

              const first = groupItems[0];
              const rest = groupItems.slice(1);

              // Resolve cityName: look up itinerary destination by IATA, fallback to item payload city
              const itiDest = itineraryDestinations.find((d: any) => d.iata_code === iataCode);
              const destinationInfo = itiDest?.destination_info;
              const cityName = destinationInfo?.cityName || itiDest?.cityName || first?.payload?.city || iataCode || '';

              result.push({
                destination: iataCode,
                cityName,
                important: first,
                essencial: rest
              });
            });

            this.sugestionByDestination = result;
            // Maintain flat essencial array (with flatIndex) for openModal() backward compatibility.
            let flatIdx = 0;
            const flatEssencial: any[] = [];
            for (const group of result) {
              for (const item of group.essencial) {
                item.flatIndex = flatIdx;
                flatEssencial.push(item);
                flatIdx++;
              }
            }
            this.sugestionEssencial = flatEssencial;
            this.noData = false;

            // Reset slide index and restart autoplay
            this.currentSlideIndex = 0;
            // Reset scroll position to the first slide
            const el = this.carouselViewport?.nativeElement;
            if (el) {
              el.scrollLeft = 0;
            }
            this.startAutoplay();

            // Emit for backward compatibility with existing listeners
            this.suggestionsCategories.emit(data);
          }

          /**
           * Appends the destination the user just searched for to the suggestions
           * payload, IF it isn't already represented by an itinerary destination.
           * Returns the same array reference when there's nothing to add, so callers
           * don't accidentally trigger change detection in vain.
           */
          appendSearchedIfMissing(itineraryPayload: any[]): any[] {
            const searched = this.actualLastSearchedDestination;
            if (!searched?.iata) {
              return itineraryPayload;
            }
            const already = itineraryPayload.some((p) => p?.destination === searched.iata);
            if (already) {
              return itineraryPayload;
            }
            itineraryPayload.push({
              providerId: null,
              categoriesId: [9],
              origin: '',
              city: searched.cityName || searched.iata,
              priceFrom: 0,
              priceTo: 20000,
              market: 2,
              others: {
                maxRequestTimeOnSeconds: 120,
                minNumResults: 4,
                maxNumResultsPerAdapter: '',
                tours: { adults: 1, children: [] }
              },
              destination: searched.iata,
              agencyId: this.actualItinerary?.agency_id ?? null,
              nationality: 'US',
              arrivalDate: searched.arrivalDate ?? null,
              departureDate: searched.departureDate ?? null
            });
            return itineraryPayload;
          }

          getSuggestionsTours(): void {
            if(this.suggestions?.TICKETS?.items?.length > 0) {
              let importantAssigned = false;
              this.suggestions.TICKETS.items.forEach((suggestion: any) => {
                // Guard: si el item está mal formado o la moneda no existe en currencies,
                // lo salteamos para no romper la iteración completa con un TypeError.
                const USDbaseSuggestion = this.currencies?.find(c => c.code === suggestion.additionalInfo?.currency)?.rate;
                const adultOption = suggestion.additionalInfo?.tours?.options[0]?.profility?.find(c => c.paxType === 'ADULT');
                const netPrice = adultOption?.netPriceBooking;

                if (!USDbaseSuggestion || !netPrice || !suggestion.additionalInfo?.images?.[0]?.thumbnail) {
                  return;
                }

                const price = netPrice / USDbaseSuggestion;
                const priceTotal = price * this.currencyAgency?.rate;

                // El destacado es el primer item que pasa el guard (no necesariamente
                // el primero del array: ese pudo no tener imagen y haber sido salteado).
                if(!importantAssigned) {
                  importantAssigned = true;
                  this.sugestionImportant = {
                    title: suggestion.title,
                    date:  this.formatDateShort(suggestion.dateIni),
                    image: suggestion?.additionalInfo?.images?.[0]?.thumbnail || null,
                    currency: suggestion.additionalInfo?.currency,
                    price: priceTotal
                  };
                } else {
                  this.sugestionEssencial.push(
                    {
                       title: suggestion.title,
                       description: suggestion.additionalInfo?.tours?.options[0]?.option_name,
                       image: suggestion?.additionalInfo?.images?.[0]?.thumbnail || null,
                       currency: suggestion.additionalInfo?.currency,
                       price: priceTotal
                    }
                  );
                }
              });

              // Si después de iterar todos los items ninguno produjo resultado válido,
              // caemos al estado "sin datos" para que el loader se vaya.
              if (!this.sugestionImportant && this.sugestionEssencial.length === 0) {
                this.noData = true;
              }
            } else {
              this.noData = true;
            }
          }

          formatDateShort(dateStr: string): string {
            const date = new Date(dateStr);
            return date.toLocaleDateString('es-AR', {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            });
          }

          getImageWidth(): string {
            const currentRoute = this.router.url; // Obtiene la ruta actual
            return currentRoute.includes('/results') ? '299px' : '315px';
          }

            openModal(template?: TemplateRef<any>, tab?: any, type?: string, index?: number) {

              const arrayAux: any[] =  [];

              arrayAux.push({searchId: 1, component: 'suggestion'});
              console.log(this.payload);
              const dialogRef = this.dialog.open(ModalsComponent, {
                width: '100%',
                height: '100%',
                maxWidth: '950px',
                panelClass: 'custom-container-transport',
                data: {
                  modalRoomRef: this.modalRef,
                  product: type === 'imperdible' ? this.suggestions.TICKETS?.items[0] : this.suggestions.TICKETS?.items.find(c => c.title === this.sugestionEssencial[index].title),
                  productQty: this.payload.qtyProduct,
                  payload: this.payload,
                  origin: 'TOURS',
                  arrayResults: arrayAux,
                  tabActive: tab,
                  payloadUpdate: this.payload,
                  paymentAgencyActive: this.paymentAgencyActive,
                  quote: true,
                  action: 'suggestion',
                  from: 'general'
                },
                disableClose: false
              });


              dialogRef.afterClosed().subscribe((result: any) => {
                if(result === 'success') {
                  this.reloadEmmit.emit();
                }
              });
            }

}
